// File: frontend/src/components/MediaRenderer.js

import React, { useState, useEffect } from 'react';

// 1. Fallback Image Import
import fallbackImage from '../assets/images/logo.jpg'; 

const FALLBACK_IMAGE = fallbackImage;

const MediaRenderer = ({ filePath, altText = "News Image", style = {}, className = "" }) => {
    const [imgSrc, setImgSrc] = useState(null);
    const [hasError, setHasError] = useState(false);

    // --- HELPER: Cloudinary Optimizer ---
    const getOptimizedUrl = (url) => {
        if (!url) return null;

        // 1. Sirf Cloudinary URLs ko optimize karein
        if (url.includes('res.cloudinary.com') && url.includes('/upload/')) {
            
            // Agar pehle se optimized parameters nahi lage hain, tabhi lagayein
            if (!url.includes('q_auto') && !url.includes('f_auto')) {
                
                // 🔥 MAGIC: Quality Auto + Format Auto + Width 800px Max
                // Isse 2MB ki file ~40KB ki ho jayegi bina quality kharab kiye
                return url.replace('/upload/', '/upload/q_auto,f_auto,w_1200/');
            }
        }
        return url;
    };

    useEffect(() => {
        if (!filePath) {
            setHasError(true);
            return;
        }

        let finalUrl = filePath;

        // 1. Handle Local Paths (Start with /uploads or no http)
        if (filePath.startsWith('/uploads') || !filePath.startsWith('http')) {
            finalUrl = `${process.env.REACT_APP_API_URL}${filePath}`;
        }

        // 2. Video Check (Video ko image ki tarah optimize mat karna)
        const isVideo = finalUrl.match(/\.(mp4|webm|ogg)$/i);

        // 3. Apply Optimization (Only for Images)
        if (!isVideo) {
            finalUrl = getOptimizedUrl(finalUrl);
        }
        
        setImgSrc(finalUrl);
        setHasError(false);

    }, [filePath]);

    const handleError = () => {
        if (!hasError) {
            setHasError(true);
            setImgSrc(FALLBACK_IMAGE);
        }
    };

    if (hasError || !imgSrc) {
        return (
            <img 
                src={FALLBACK_IMAGE} 
                alt="Fallback" 
                className={className} 
                style={{ ...style, objectFit: 'contain', backgroundColor: '#f8f9fa', padding: '10px' }} 
            />
        );
    }

    // Video Handling
    if (imgSrc.match(/\.(mp4|webm|ogg)$/i)) {
        return (
            <video controls className={className} style={style}>
                <source src={imgSrc} type="video/mp4" />
                Your browser does not support the video tag.
            </video>
        );
    }

    // Image Handling
    return (
        <img 
            src={imgSrc} 
            alt={altText} 
            className={className} 
            style={style}
            onError={handleError}
            loading="lazy" // Native Lazy Loading
        />
    );
};

export default MediaRenderer;